import React from 'react';
import Compare from '../../common/compare/Compare';
import OptionsFilter from './filters/OptionsFilter';
import {
  getAppPath,
  getFilteredTrims,
  getHeaderDataForStyle,
  setDefaultTrimIndex,
} from './utils';
import { useLocation } from 'react-router-dom';
import { useTranslate } from '../../../core/translate';
import FullPageCompareHeader from './fullPageCompareHeading/FullPageCompareHeader';
import LoadingSpecsCompare from '../../common/loading/LoadingSpecsCompare';
import useCompareScrolling, {
  compareScrollToRef,
  useCompareIsScrolledUp,
} from './useCompareScrolling';

const analyticsKey = 'compare trims';
// TODO: Unit tests
// TODO: Analytics
const TrimFeatureCompareInner = (props) => {
  const {
    config,
    features,
    displayFilterCount,
    displayInTableFilter,
    driveTypeSectionEl,
    filteredOptions,
    selections,
  } = props;
  const { styleIds: valuesByStyle, groups } = features;
  const [scrolling] = useCompareScrolling();
  const [isScrolledUp, setIsScrolledUp] = useCompareIsScrolledUp();
  const filteredTrims = getFilteredTrims(filteredOptions, config);

  const location = useLocation();

  const translate = useTranslate();

  const styleId = new URLSearchParams(location.search).get('styleId');
  const section = new URLSearchParams(location.search).get('section');

  const getTrimItems = () => {
    let trims = filteredTrims;
    return trims;
  };

  const getSelectedIndex = () => {
    if (styleId) {
      return setDefaultTrimIndex(filteredTrims, selections.trimName);
    }
    return 0;
  };

  const trimItems = getTrimItems();
  const selectedTrimIndex = getSelectedIndex();
  const headers = trimItems.map((style) => getHeaderDataForStyle(style));

  const buildExteriorPath = (styleId) => {
    const currentPath = location.pathname;
    const pathName = getAppPath(currentPath);
    return `${pathName}/exterior?styleId=${styleId}`;
  };

  const columns = trimItems.map((style) => {
    return {
      data: style,
      selectionLink: buildExteriorPath(style.styleId),
      groups: valuesByStyle[style.styleId],
    };
  });

  const filterText = translate('feature.compare.filtered.v3', {
    number: trimItems && trimItems.length,
  });

  return (
    <Compare
      headers={headers}
      columns={columns}
      compareGroups={groups}
      config={config}
      isFeatures={true}
      isScrolled={scrolling}
      isScrolledUp={isScrolledUp}
      setIsScrolledUp={setIsScrolledUp}
      filterText={trimItems && trimItems.length && filterText}
      displayFilterCount={displayFilterCount}
      displayInTableFilter={displayInTableFilter}
      driveTypeSectionEl={driveTypeSectionEl}
      defaultSection={section}
      analyticsKey={analyticsKey}
      selectedIndex={selectedTrimIndex}
      scrollToSearchFeature={compareScrollToRef}
    />
  );
};

const TrimFeatureCompare = (props) => {
  const { config, options, selections, headerTitle, onClose } = props;
  return (
    <>
      {config ? (
        <>
          <FullPageCompareHeader
            title={headerTitle}
            onClose={onClose}
            analyticsKey={analyticsKey}
          />
          <OptionsFilter
            selections={selections}
            options={options}
            config={config}
            analyticsKey={analyticsKey}>
            {(
              filteredOptions,
              displayFilterCount,
              displayInTableFilter,
              driveTypeSectionEl
            ) => (
              <TrimFeatureCompareInner
                {...props}
                filteredOptions={filteredOptions}
                displayFilterCount={displayFilterCount}
                driveTypeSectionEl={driveTypeSectionEl}
                displayInTableFilter={displayInTableFilter}
                selections={selections}></TrimFeatureCompareInner>
            )}
          </OptionsFilter>
        </>
      ) : (
        <LoadingSpecsCompare />
      )}
    </>
  );
};

export default TrimFeatureCompare;
